import axios from 'axios';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBTable,
  MDBTableBody
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { CategoryContext } from '../context/CategoryContext';
const CategoryCard = ({category, setActiveTab, activeTab, setIsCategoryFormSubmitted, setShowCategoryModal,setCategoryToUpdate, firm}) => {
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const {setCategoryData} = useContext(CategoryContext);
    const handleDelete = () => {
        axios({
            method: 'delete',
            url: `${baseUrl}/categories/${category.id}`,
            data: Array.from([category.id])
        })
        .then(response => {
            if(response.status === 200) {
                setCategoryData(prevCategories => {
                    const updatedCategories = prevCategories.filter(cat => cat.id !== category.id);
                    if (updatedCategories.length > 0) {
                        if(activeTab === category.name) setActiveTab(updatedCategories[0].name);
                    }else{
                        setCategoryData([]);
                        setIsCategoryFormSubmitted && setIsCategoryFormSubmitted(false)
                    }
                    return updatedCategories;
                });
            }
        })
        .catch(err => console.error(err));
    };
    const handleUpdate = useCallback(() => {
        setShowCategoryModal(true);        
        category.firmId = firm; 
        setCategoryToUpdate(category);
     
    }, [setShowCategoryModal, setCategoryToUpdate, category,firm]);

    return (
        <MDBCard key={category.id} className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
          {/* <MDBCardImage  src= {category.thumbnail && category.thumbnail.replace('_thumbnail', '')}  hover overlay='white-slight' alt='...'/> */}
        <MDBCardBody>
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-center'>
       {category.thumbnail && <div style={{ maxWidth: "30%" , textAlign: "center"}} className='me-5 mb-3 mb-md-0'>
                            <img
                                src={category.thumbnail && category.thumbnail.replace('_thumbnail', '')}
                                alt=''
                                style={{ width: "150px" , margin: "auto"}}
                                
                            />
                        </div>}
        <MDBTable align="middle" small borderless>
  <MDBTableBody>
    <tr>
      <th style={{ textAlign: 'left' }} scope='row'>Name</th>
      <td style={{ textAlign: 'left' }}>{category.name}</td>
    </tr>
    <tr>
      <th style={{ textAlign: 'left' }} scope='row'>Description</th>
      <td style={{ textAlign: 'left' }}>{category.description}</td>
    </tr>
    <tr>
      <th style={{ textAlign: 'left' }} scope='row'>Created Date</th>
      <td style={{ textAlign: 'left' }}>{category.date && category.date.createdDate}</td>
    </tr>
    <tr>
      <th style={{ textAlign: 'left' }} scope='row'>Modified Date</th>
      <td style={{ textAlign: 'left' }}>{category.date && category.date.modifiedDate}</td>
    </tr>
    <tr>
      <th style={{ textAlign: 'left' }} scope='row'>Domains</th>
      <td style={{ textAlign: 'left' }}>
        {Object.keys(category.domainIdName).map((key, index) => (
          <div key={index}>{category.domainIdName[key]}</div>
        ))}
      </td>
    </tr>
  </MDBTableBody>
</MDBTable>
</div>

        </MDBCardBody>
        <div className="d-grid gap-2 d-md-block" style={{ marginBottom: '20px' }} >
           <MDBBtn color='primary' className='me-2' onClick={handleUpdate}>Update</MDBBtn> 
            <MDBBtn color='success' onClick={handleDelete}>Delete</MDBBtn>
        </div>
    </MDBCard>
    
    

    
    );
};

CategoryCard.propTypes = {
     
    setCategoryData: PropTypes.func,
    category: PropTypes.object,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.string,
    setIsCategoryFormSubmitted: PropTypes.func,
    setCategoryToUpdate: PropTypes.func,
    setShowCategoryModal: PropTypes.func,
    firm: PropTypes.string,
}
export default CategoryCard;